import HeroImage from "@/assets/category/hero.jpg";
import { MdOutlineArrowBack } from "react-icons/md";
import { useRouter } from "next/router";

interface BannerProps {
  title: string;
  small?: string;
}

const Banner: React.FC<BannerProps> = (props) => {
  const { title, small } = props;
  const router = useRouter();

  return (
    <div
      className="w-screen py-8"
      style={{ backgroundImage: `url(${HeroImage.src})` }}
    >
      <div className="container mx-auto">
        <button
          onClick={() => router.back()}
          className="flex gap-2 items-center"
        >
          <MdOutlineArrowBack />
          Back
        </button>
        <h1 className="text-6xl mt-4">{title}</h1>
        {small && <p className="mt-6 font-medium">{small}</p>}
      </div>
    </div>
  );
};

export default Banner;
